import apiService from './apiService';

class ScheduleService {
  async listSchedules() {
    return apiService.listSchedules();
  }

  async createSchedule(payload) {
    return apiService.createSchedule(payload);
  }

  async getSchedule(scheduleId) {
    return apiService.getSchedule(scheduleId);
  }

  async updateSchedule(scheduleId, payload) {
    return apiService.updateSchedule(scheduleId, payload);
  }

  async deleteSchedule(scheduleId) {
    return apiService.deleteSchedule(scheduleId);
  }

  async toggleSchedule(scheduleId) {
    return apiService.toggleSchedule(scheduleId);
  }

  async runScheduleNow(scheduleId) {
    return apiService.runScheduleNow(scheduleId);
  }

  async listScheduleLogs(scheduleId, limit = 25) {
    return apiService.listScheduleLogs(scheduleId, limit);
  }

  async clearScheduleLogs(scheduleId) {
    return apiService.clearScheduleLogs(scheduleId);
  }
}

const scheduleService = new ScheduleService();
export default scheduleService;
